interface Props {
  size: number;
}

export const Spacing = ({ size }: Props) => {
  return <div style={{ flex: 1, minHeight: size, maxHeight: size }} />;
};
